// extracted by mini-css-extract-plugin
export default {"gif":"q_br","gif--wrapped":"q_bs"};